import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolumeX = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.1666 7.49996L14.1666 12.5M14.1666 7.49996L19.1666 12.5M9.16663 4.16663L4.99996 7.49996H1.66663V12.5H4.99996L9.16663 15.8333V4.16663Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgVolumeX;
